/**
 * 打赏配置
 */
const runtimeCfg = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}

export const TIP_CONFIG = {
  apiBaseUrl:
    runtimeCfg.API_BASE_URL ||
    import.meta.env.VITE_API_BASE_URL ||
    'https://ematalking.cn',
  authorName: 'EmaTalking 开发者',
  authorTagline: '持续维护与迭代中，你的支持是最大的动力 ☕',
  presetAmounts: [6.66, 8.88, 18.88, 28.88, 66.66, 88.88],
  defaultMemo: 'EmaTalking 打赏',
  minAmount: 0.01,
  maxAmount: 9999,
}
